module.exports = __webpack_public_path__ + "img/vector.8b0ee692.svg";